module.exports = __webpack_public_path__ + "img/cuff button diameter.45dc592d.png";